import { ButtonLink } from '../components/ui/ButtonLink'
import { GameCard } from '../components/ui/GameCard'
import { SectionTitle } from '../components/ui/SectionTitle'
import { links } from '../config/links'
import { games, team, technologies } from '../data/site-content'
import { useVisualEffects } from '../hooks/useVisualEffects'
import logo from '../../assets/aexion-logo.webp'
import agroImage from '../../assets/agro-reference.webp'

export function HomePage() {
  useVisualEffects()

  return (
    <>
      <section id="inicio" className="hero">
        <img className="hero-image" src="/hero-reference-optimized-v2.webp" alt="" width="1536" height="1024" fetchPriority="high" /><div className="hero-overlay" />
        <div className="hero-content reveal">
          <img className="hero-logo" src={logo} alt="AEXION Studios" width="520" height="419" />
          <h1>CRIAMOS UNIVERSOS<br />QUE <span>INSPIRAM</span> PESSOAS.</h1>
          <p>Desenvolvemos jogos inovadores que educam, entretêm e conectam pessoas por meio de experiências inesquecíveis.</p>
          <div className="actions hero-actions"><ButtonLink href="/projetos">Conheça nossos projetos <b>→</b></ButtonLink><ButtonLink href="/demos" variant="outline">Explorar demonstrações</ButtonLink></div>
        </div>
      </section>

      <section id="agroaprendiz" className="agro-feature">
        <img className="agro-background" src={agroImage} alt="" width="1536" height="1024" loading="lazy" /><div className="agro-shade" />
        <div className="agro-copy reveal">
          <small>Nosso primeiro universo</small><h2>AGRO<span>APRENDIZ</span></h2>
          <div className="tags">Educação · Simulação · RPG · Agro</div>
          <p>Uma experiência educacional gamificada que aproxima adolescentes e jovens do universo agropecuário.</p>
          <blockquote>“Plante hoje, colha um amanhã.”</blockquote>
          <div className="actions">
            <ButtonLink href="/agroaprendiz" green>Conheça o projeto <b>→</b></ButtonLink>
            <ButtonLink href={links.agroAprendiz} target="_blank" rel="noopener noreferrer" variant="outline">Site oficial ↗</ButtonLink>
          </div>
        </div>
      </section>

      <section id="jogos" className="section projects">
        <SectionTitle eyebrow="Em desenvolvimento" title="NOSSOS PRÓXIMOS UNIVERSOS" />
        <div className="cards">{games.map((game) => <GameCard key={game.title} {...game} />)}</div>
      </section>

      <section id="sobre" className="section about">
        <div className="about-text reveal">
          <small>Sobre a AEXION</small><h2>QUEM SOMOS</h2>
          <p>A AEXION Studios é um estúdio independente criado para desenvolver universos originais, jogos com propósito e experiências digitais memoráveis.</p>
          <p>Nosso primeiro produto é o AgroAprendiz, uma propriedade intelectual educacional voltada à aproximação de jovens com a agropecuária.</p>
          <a href="/sobre">Saiba mais sobre nós →</a>
        </div>
        <div className="core reveal" aria-hidden="true"><div className="core-cube"><i /><i /><i /></div></div>
        <div className="values reveal">
          <article><span>◈</span><div><h3>Criatividade</h3><p>Ideias originais que dão vida a universos únicos.</p></div></article>
          <article><span>⌁</span><div><h3>Tecnologia</h3><p>Ferramentas modernas para experiências de qualidade.</p></div></article>
          <article><span>♢</span><div><h3>Propósito</h3><p>Jogos capazes de educar, inspirar e entreter.</p></div></article>
          <article><span>◎</span><div><h3>Comunidade</h3><p>Jogadores e parceiros no centro da construção.</p></div></article>
        </div>
      </section>

      <section id="tecnologia" className="section technology">
        <SectionTitle eyebrow="Tecnologia AEXION" title="CONSTRUÍMOS COM O FUTURO EM MENTE." description="Desenvolvimento de jogos, aplicações web, inteligência artificial, experiências educacionais e protótipos interativos." />
        <div className="tech-grid">{technologies.map((item) => <article key={item.title} className="reveal tilt-card"><b>{item.eyebrow}</b><h3>{item.title}</h3><p>{item.description}</p></article>)}</div>
      </section>

      <section id="equipe" className="section team">
        <SectionTitle eyebrow="Nosso time" title="PESSOAS POR TRÁS DOS UNIVERSOS" />
        <div className="team-grid">{team.map((person) => <article key={person.name} className="person reveal tilt-card"><div className={`avatar ${person.modifier ?? ''}`}>{person.initials}</div><div><h3>{person.name}</h3><strong>{person.role}</strong><p>{person.description}</p></div></article>)}</div>
      </section>

      <section id="contato" className="contact">
        <div className="reveal"><small>Contato</small><h2>VAMOS CRIAR ALGO<br /><span>EXTRAORDINÁRIO?</span></h2><p>Área para parceiros, clientes, investidores, imprensa e futuros integrantes da equipe.</p><ButtonLink href="/contato">Entrar em contato →</ButtonLink></div>
      </section>
    </>
  )
}
